import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TableModule } from '@appkit4/angular-components/table';
import { SharedModule } from '@shared/shared.module';
import { MonitorComponent } from './components/monitor.component';
import { MonitorRoutingModule } from './monitor-routing.module';

@NgModule({
  declarations: [MonitorComponent],
  imports: [CommonModule, MonitorRoutingModule, SharedModule, TableModule],
})
export class MonitorModule {}
